// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { KnowledgeBaseRetrievalClient } from "./knowledgeBaseRetrievalClient.js";
export type {
  KnowledgeBaseRetrievalContext,
  KnowledgeBaseRetrievalClientOptionalParams,
  RetrieveOptionalParams,
} from "./api/index.js";
